module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('img', {
    attrs: {
      "alt": "logo certisign",
      "src": require("../../../static/img/logo_certisign_24_white.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d71df7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/Footer.vue
// module id = 255
// module chunks = 0